import React, {Component} from 'react';
import PercentItem from './PercentItem';
import {FormattedMessage} from 'react-intl';

class TopSourcePages extends Component {
    render() {
        const landingMap = {};
        this.props.visits.forEach(({referrer}) => {
            const page = referrer ? new URL(referrer).host : 'Direct';
            landingMap[page] = landingMap[page] ? landingMap[page] + 1 : 1;
        })
        const total = this.props.visits.length;
        const sortedArray = Object.keys(landingMap).map((key) => {
            const count = landingMap[key];
            return {title: key, count, percent: Math.round((count * 100) / total)}
        }).sort((a, b) => b.count - a.count).slice(0, 5);
        return (
            <div className={"card"}>
                <div className="card-header"><FormattedMessage id={"Click Origins"}/></div>
                <ul className="list-group list-group-flush">
                    {
                        sortedArray.map(({title, percent}) => {
                            return <li className={"list-group-item"}>
                                <PercentItem title={title} percent={percent}/>
                            </li>
                        })
                    }
                </ul>
            </div>
        );
    }
}

export default TopSourcePages;
